import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { Fade } from 'react-reveal';
import { Actions } from '../../../flux';
import { images, texts, videos, diretoria } from '../../../settings';
import { DelayLink, CardSliderFotos } from '../../../components';

import './Diretoria.scss';

class Diretoria extends Component {
  constructor(props) {
    super(props);

    this.state = {
      width: window.innerWidth,
    };

    this.images = images;
    this.videos = videos;
    this.texts = texts;
    this.diretoriaSlider = diretoria;

    this.contentText = React.createRef();
    this.runTransition = this.runTransition.bind(this);
  }

  scrollTop() {
    window.scrollTo({ top: this.contentText.current.offsetTop });
  }

  runTransition() {
    Actions.globalTransition();
  }

  componentDidMount() {
    Actions.headerIntern();
    this.scrollTop();
  }

  render() {
    return (
      <div className="views" ref={this.contentText}>
        <Helmet>
          <title>Diretoria - Governança Corporativa - {this.texts.title}</title>
        </Helmet>

        <div className="diretoria-home page-gradient page-gradient--green bg-gray" ref="diretoria-home">
          <section className="diretoria-home-area page-gradient__header">
            <div className="container">
              <div className="row">
                <div className="page-header-container col-12">
                  <Fade bottom>
                    <div className="page-header col-6">
                      <h1 className="page-header__title">Diretoria</h1>
                      <p className="page-header__description gri_text">
                        A Diretoria não desempenha atividades executivas na Associação. São pessoas que ocupam o cargo
                        de forma voluntária, escolhidas em eleições a cada dois anos, e que refletem a pluralidade dos
                        diferentes tamanhos e segmentos das instituições que representamos.
                        <br />
                        <br />
                        Ela é formada por 22 membros: um presidente, oito vice-presidentes e até 13 diretores. Eles se
                        reúnem pelo menos uma vez por mês e pode haver reuniões extraordinárias se o presidente ou a
                        maioria dos participantes convocarem. Todos podem ser reeleitos por períodos sucessivos, menos o
                        presidente, que só pode ser reeleito uma vez, ou seja, permanecer até quatro anos no
                        <span className="gri_text--ultima-palavra">
                          {' '}
                          cargo.
                          <span className="gri_label">
                            GRI <b>102-25</b>
                          </span>
                        </span>
                      </p>
                    </div>
                    <div className="page-header-image col-6">
                      <img src={images.diretoria.pessoa1} />
                      <img src={images.diretoria.pessoa1_hover} />
                    </div>
                  </Fade>
                </div>
              </div>
            </div>
          </section>

          <section className="diretoria-body diretoria-body--card">
            <div className="container">
              <div className="row">
                <div className=" ">
                  <div className="diretoria-body__content">
                    <Fade bottom>
                      <div className="diretoria-body__content-card">
                        <h2 className="green">As principais responsabilidades são:</h2>
                        <div className="diretoria-body__content-itens">
                          <div>
                            <p>Dirigir e administrar a Associação</p>
                          </div>
                          <div>
                            <p>Fazer cumprir o estatuto social, suas normas e seus procedimentos.</p>
                          </div>
                          <div>
                            <p>Fazer cumprir as decisões da Assembleia Geral.</p>
                          </div>
                          <div>
                            <p>
                              Definir a agenda estratégica, indicando e aprovando as iniciativas prioritárias para o ano
                              seguinte.
                            </p>
                          </div>
                        </div>
                      </div>
                    </Fade>
                    <Fade bottom>
                      <h2 className="diretoria-body__content-title">
                        Em dezembro de 2019, a <span className="green">Diretoria</span> era composta por:
                      </h2>
                      <CardSliderFotos
                        items={this.diretoriaSlider.diretores}
                        url={this.images.diretoria.urlDiretores}
                        color={'green'}
                      />
                    </Fade>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section className="diretoria-box-area">
            <div className="container">
              <div className="row">
                <div className="col-12">
                  <Fade>
                    <div className="box-pill box-pill--blue box-pill--center">
                      <div className="box-pill__content box-pill__content--full">
                        <div className="row">
                          <div className="col col-10 col--text col--text--end" style={{ minHeight: 'auto' }}>
                            <h4>Veja como é formado o nosso Comitê executivo</h4>
                            <DelayLink
                              to="/governanca-corporativa/comite-executivo"
                              className="button button--aylen button--white-to-blue button--border-medium button--size-m button--round-l button--text-thick"
                            >
                              Explorar
                            </DelayLink>
                          </div>
                          <div className="col col-2">
                            <img
                              src={images.comite_executivo.ilustra1}
                              className="pessoa_destaque pessoa_destaque--1"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </Fade>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    );
  }
}

export { Diretoria };
